"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tint = exports.shade = exports.mix = exports.fade = exports.desaturate = exports.contrast = void 0;
const polished_1 = require("polished");
function contrast(color, light, dark) {
    return (0, polished_1.readableColor)(color, light, dark);
}
exports.contrast = contrast;
function desaturate(color, factor) {
    return (0, polished_1.desaturate)(factor, color);
}
exports.desaturate = desaturate;
function fade(color, alpha) {
    const colorRgb = (0, polished_1.parseToRgb)(color);
    return (0, polished_1.rgbToColorString)({ ...colorRgb, alpha });
}
exports.fade = fade;
function mix(color, mixColor, factor) {
    return (0, polished_1.mix)(1 - factor, color, mixColor);
}
exports.mix = mix;
function shade(color, factor) {
    return mix(color, "#000000", factor);
}
exports.shade = shade;
function tint(color, factor) {
    return mix(color, "#ffffff", factor);
}
exports.tint = tint;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29sb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi90aGVtaW5nL3V0aWxzL2NvbG9yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLHVDQUErRztBQUkvRyxTQUFnQixRQUFRLENBQUMsS0FBWSxFQUFFLEtBQWEsRUFBRSxJQUFZO0lBQ2hFLE9BQU8sSUFBQSx3QkFBYSxFQUFDLEtBQUssRUFBRSxLQUFLLEVBQUUsSUFBSSxDQUFDLENBQUM7QUFDM0MsQ0FBQztBQUZELDRCQUVDO0FBRUQsU0FBZ0IsVUFBVSxDQUFDLEtBQVksRUFBRSxNQUFjO0lBQ3JELE9BQU8sSUFBQSxxQkFBVyxFQUFDLE1BQU0sRUFBRSxLQUFLLENBQUMsQ0FBQztBQUNwQyxDQUFDO0FBRkQsZ0NBRUM7QUFFRCxTQUFnQixJQUFJLENBQUMsS0FBWSxFQUFFLEtBQWE7SUFDOUMsTUFBTSxRQUFRLEdBQUcsSUFBQSxxQkFBVSxFQUFDLEtBQUssQ0FBQyxDQUFDO0lBRW5DLE9BQU8sSUFBQSwyQkFBZ0IsRUFBQyxFQUFFLEdBQUcsUUFBUSxFQUFFLEtBQUssRUFBRSxDQUFDLENBQUM7QUFDbEQsQ0FBQztBQUpELG9CQUlDO0FBRUQsU0FBZ0IsR0FBRyxDQUFDLEtBQVksRUFBRSxRQUFlLEVBQUUsTUFBYztJQUMvRCxPQUFPLElBQUEsY0FBSSxFQUFDLENBQUMsR0FBRyxNQUFNLEVBQUUsS0FBSyxFQUFFLFFBQVEsQ0FBQyxDQUFDO0FBQzNDLENBQUM7QUFGRCxrQkFFQztBQUVELFNBQWdCLEtBQUssQ0FBQyxLQUFZLEVBQUUsTUFBYztJQUNoRCxPQUFPLEdBQUcsQ0FBQyxLQUFLLEVBQUUsU0FBUyxFQUFFLE1BQU0sQ0FBQyxDQUFDO0FBQ3ZDLENBQUM7QUFGRCxzQkFFQztBQUVELFNBQWdCLElBQUksQ0FBQyxLQUFZLEVBQUUsTUFBYztJQUMvQyxPQUFPLEdBQUcsQ0FBQyxLQUFLLEVBQUUsU0FBUyxFQUFFLE1BQU0sQ0FBQyxDQUFDO0FBQ3ZDLENBQUM7QUFGRCxvQkFFQyJ9